import { ColorName } from '@shinetools/sunshine';

import * as Types from '../../../../__generated__/GQL';
import { Device } from '../../types';
import locales from './locales';

export const getBadgeColor = (device: Device): ColorName => {
  if (device.status === Types.AuthenticationDeviceStatus.Trusted) {
    return 'green';
  }
  if (device.status === Types.AuthenticationDeviceStatus.Blocked) {
    return 'red';
  }
  return 'yellow';
};

export const getBadgeLabel = (device: Device): string => {
  if (device.status === Types.AuthenticationDeviceStatus.Trusted) {
    return locales.authorized;
  }
  if (device.status === Types.AuthenticationDeviceStatus.Blocked) {
    return locales.blocked;
  }
  return locales.pending;
};
